import React from 'react';
import { TrendingUp, TrendingDown, X } from 'lucide-react';
import '../Restrain/Restrain.css';

interface BuySellButtonsProps {
  canTrade: boolean;
  isMarketOpen: boolean;
  isCrypto?: boolean;
  handleBuy: () => void;
  handleSell: () => void;
  handleFlatten: () => void;
  /** Restrain refusal text when this side would change the position size. */
  buyLock?: string | null;
  sellLock?: string | null;
  /**
   * Button text (utils/exitOnly manualOrderButton). In a position the
   * opposite side is exit-only and says so: "CLOSE 3" / "EXIT 2 of 3 short";
   * a side restrain blocks reads "LOCKED · RST 1:52:10". Defaults to "BUY" / "SELL".
   */
  buyLabel?: string;
  sellLabel?: string;
  /** Tooltip for each side; the restrain lock text wins when no title is given. */
  buyTitle?: string;
  sellTitle?: string;
}

/** Long labels (EXIT / LOCKED) get a smaller, fixed-width-digit font so the bar doesn't jump. */
const longLabel = (label: string) => (label.length > 8 ? ' order-btn-long-label' : '');

export const BuySellButtons: React.FC<BuySellButtonsProps> = ({
  canTrade,
  isMarketOpen,
  isCrypto = false,
  handleBuy,
  handleSell,
  handleFlatten,
  buyLock = null,
  sellLock = null,
  buyLabel = 'BUY',
  sellLabel = 'SELL',
  buyTitle,
  sellTitle,
}) => {
  const tradingDisabled = !canTrade || (!isMarketOpen && !isCrypto);

  return (
    <div className="trading-action-buttons">
      <button
        className={`trading-buy-btn${buyLock ? ' restrain-locked' : ''}${longLabel(buyLabel)}`}
        onClick={handleBuy}
        disabled={tradingDisabled || !!buyLock}
        title={tradingDisabled ? (isCrypto ? 'Chart Only' : 'Trading unavailable') : buyTitle ?? buyLock ?? 'Place Buy Order'}
      >
        <TrendingUp size={11} />
        <span>{buyLabel}</span>
      </button>
      <button
        className={`trading-sell-btn${sellLock ? ' restrain-locked' : ''}${longLabel(sellLabel)}`}
        onClick={handleSell}
        disabled={tradingDisabled || !!sellLock}
        title={tradingDisabled ? (isCrypto ? 'Chart Only' : 'Trading unavailable') : sellTitle ?? sellLock ?? 'Place Sell Order'}
      >
        <TrendingDown size={11} />
        <span>{sellLabel}</span>
      </button>
      <button
        className="trading-flat-btn"
        onClick={handleFlatten}
        disabled={!canTrade}
        title={!canTrade ? 'Not connected' : 'Flatten Position'}
      >
        <X size={11} />
        <span>FLAT</span>
      </button>
    </div>
  );
};
